package org.multiplatform.kotfolio.util

import androidx.compose.runtime.Immutable
import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.persistentMapOf
import org.multiplatform.kotfolio.di.Project
import org.multiplatform.kotfolio.di.Work
import org.multiplatform.kotfolio.domain.Blog
import org.multiplatform.kotfolio.models.BlogEnum

@Immutable
object PortfolioData {
    private const val JETPACK_COMPOSE = "Jetpack Compose"

    private const val ANDROID_STUDIO = "Android Studio"

    private const val FLUTTER = "Flutter"

    private const val JAVA = "Java"
    private const val KOTLIN = "Kotlin"

    private const val KOTLIN_NOTEBOOK = "Kotlin Notebook"

    private const val COROUTINES = "Coroutines"

    private const val KOTLIN_MULTIPLATFORM = "Kotlin Multiplatform"

    private const val KIDS = "Kids"

    private const val KOBWEB = "Kobweb"

    private const val FLIPKART= "Flipkart"

    /*
     val blogList by lazy {
        mutableListOf(
            Blog(1,"1000","Inheritance", "Inheritance is the process by which object of one class acquires (copying) the properties of another class. Explain types of inheritance, rules, is - A, relationship and method overriding.", Constants.JAVA_INHERITANCE_URL, language = "Java"),
       )
     }
    */

    val blogList = persistentMapOf(
        // Java
        JAVA to buildList {
            addAll(
                listOf(
                    Blog(1, "", links = listOf("Inheritance" to Constants.JAVA_INHERITANCE_URL), blogEnum = BlogEnum.InheritanceJava),
                    Blog(2, "", links = listOf("Abstract class" to Constants.JAVA_ABSTRACT_CLASS_URL), blogEnum = BlogEnum.AbstractClassJava),
                    Blog(3, "", links = listOf("Multithreading" to Constants.JAVA_THREAD_URL), blogEnum = BlogEnum.MultithreadingJava),
                    Blog(4, "", links = listOf("Java Difference" to "https://docs.google.com/document/d/17nWvgEqZdVKJp0Lyv1-4MaEeL6Dp1BGs/edit?usp=sharing&ouid=102675730981417844297&rtpof=true&sd=true"), blogEnum = BlogEnum.DifferenceJava)
                )
            )
        },

        ANDROID_STUDIO to buildList {
            addAll(
                listOf(
                    Blog(1, "", links = listOf("Gradle" to Constants.GRADLE_URL), blogEnum = BlogEnum.GradleAndroidStudio)
                )
            )
        },

        //Flutter
        FLUTTER to buildList {
            addAll(
                listOf(
                    Blog(1, "", links = listOf("Basic" to Flutter.WIDGET_ARCHITECTURE_URL), blogEnum = BlogEnum.BasicFlutter),
                    Blog(2, "", links = listOf("Main Widget" to Flutter.WIDGET_LIFECYCLE_URL), blogEnum = BlogEnum.MainWidgetFlutter),
                    Blog(3, "", links = listOf("Clean Architecture, Solid design structure" to Flutter.CLEAN_ARCHITECTURE_URL), blogEnum = BlogEnum.CleanArchitectureFlutter),
                    Blog(4, "", links = listOf("BLoC State Management" to Flutter.BLOC_URL), blogEnum = BlogEnum.BLoCStateManagementFlutter),
                    Blog(5, "", links = listOf("Riverpod State Management" to "https://medium.com/@kamal.lakhani56/riverpod-state-management-flutter-8b4f303c27c2"), blogEnum = BlogEnum.RiverPodManagementFlutter),
                    Blog(6, "", links = listOf("GetX State Management" to Flutter.GETX_URL), blogEnum = BlogEnum.GetXStateManagementFlutter),
                    Blog(7, "", links = listOf("get_it - Dependency Injection" to Flutter.GET_IT_DI_URL), blogEnum = BlogEnum.DependencyInjectionFlutter),
                    Blog(8, "", links = listOf("freezed annotation" to Flutter.FREEZED_URL), blogEnum = BlogEnum.FreezedAnnotationFlutter),
                    Blog(9, "", links = listOf("Asynchronous" to Flutter.ASYNCHRONOUS_URL), blogEnum = BlogEnum.AsynchronousFlutter),
                    Blog(10, "", links = listOf("Isolate" to Flutter.ISOLATE_URL), blogEnum = BlogEnum.IsolateFlutter),
                    Blog(11, "", links = listOf("Channel communication" to Flutter.PLUGIN_URL), blogEnum = BlogEnum.ChannelCommunicationFlutter),
                    Blog(12, "", links = listOf("Interview question - 123" to Flutter.INTERVIEW_QUESTIONS_URL), blogEnum = BlogEnum.QuestionsFlutter)
                )
            )
        },

        //Kotlin
        KOTLIN to buildList {
            addAll(
                listOf(
                    Blog(1, "", links = listOf("Design Patterns" to Kotlin.DESIGN_PATTERNS_URL), blogEnum = BlogEnum.DesignPatternKotlin),
                    Blog(2, "", links = listOf("Interview question - 248+" to Kotlin.QUESTIONS_URL), blogEnum = BlogEnum.QuestionsKotlin),
                    Blog(3, "", links = listOf("Higher Order Functions (HOF)" to Kotlin.HIGHER_ORDER_FUNCTIONS_URL), blogEnum = BlogEnum.HOFKotlin),
                    Blog(4, "", links = listOf("Filter Collection() - 57" to Kotlin.FILTER_COLLECTION_URL), blogEnum = BlogEnum.FilterCollectionKotlin),
                    Blog(5, "", links = listOf("Race condition, Volatile, atomic, synchronized, Mutex (Latest way)" to Kotlin.MUTEX_URL), blogEnum = BlogEnum.RaceConditionKotlin),
                    Blog(6, "", links = listOf("New Feature" to Kotlin.KotlinNewFeature.NEW_FEATURE_URL), blogEnum = BlogEnum.NewFeatureKotlin),
                )
            )
        },

        //Coroutines
        COROUTINES to buildList {
            addAll(
                listOf(
                    Blog(1,"", links = listOf("Coroutines" to Coroutines.BASIC_URL), blogEnum = BlogEnum.BasicCoroutines),
                    Blog(2,"", links = listOf("Suspending function, Coroutine Builder" to Coroutines.CREATE_URL), blogEnum = BlogEnum.SuspendingFunctionsCoroutines),
                    Blog(3,"", links = listOf("Dispatchers" to Coroutines.DISPATCHERS_URL), blogEnum = BlogEnum.DispatchersCoroutines),
                    Blog(4,"", links = listOf("Flow Basic, Create, Builders, flowOn() Operator, Combine Flow, Combine | Zip | Filter programmatically" to Coroutines.FLOW_BASIC_URL), blogEnum = BlogEnum.FlowBasicCoroutines),
                    Blog(5,"", links = listOf("StateFlow and SharedFlow" to Coroutines.STATE_SHARED_FLOW_URL), blogEnum = BlogEnum.StateSharedFlowCoroutines),
                    Blog(6,"", links = listOf("stateIn and shareIn" to Coroutines.CONVERT_FLOW_URL), blogEnum = BlogEnum.StateShareInCoroutines),
                    Blog(7,"", links = listOf("Coroutine scope, CoroutineContext, exception handling (Throws, CoroutineExceptionHandler, continuation.resumeWithException()), callback, suspendCancellableCoroutine, suspendCoroutine and Channel Communication" to Coroutines.CONTEXT_CANCELLATION_URL), blogEnum = BlogEnum.ScopeCoroutines),
                    Blog(8,"", links = listOf("Semaphore parallelism" to Coroutines.SEMAPHORE_URL), blogEnum = BlogEnum.SemaphoreCoroutines),
                    Blog(9,"", links = listOf("Interview question - 160" to Coroutines.QUESTIONS_URL), blogEnum = BlogEnum.QuestionsCoroutines),
                )
            )
        },

        //Jetpack Compose
        JETPACK_COMPOSE to buildList {
            addAll(
                listOf(
                    Blog(1, "", links = listOf("Basic" to JetpackCompose.BASIC_URL), blogEnum = BlogEnum.BasicJC),
                    Blog(2, "", links = listOf("Modifiers" to JetpackCompose.MODIFIER_URL),  blogEnum = BlogEnum.ModifiersJC),
                    Blog(3, "", links = listOf("Composable lifecycle" to JetpackCompose.LIFE_CYCLE_URL), blogEnum = BlogEnum.ComposeLifeCycleJC),
                    Blog(4, "", links = listOf("Unidirectional data flow (UDF)" to JetpackCompose.UDF_URL), blogEnum = BlogEnum.DataFlowJC),
                    Blog(5, "", links = listOf("State Hosting (Local State and Hoist State)" to JetpackCompose.STATE_HOSTING_URL), blogEnum = BlogEnum.StateHostingJC),
                    Blog(6, "", links = listOf("Scoped Slots (Composable Slotting)" to JetpackCompose.SCOPED_SLOTS_URL), blogEnum = BlogEnum.ScopedSlotsJC),
                    Blog(7, "", links = listOf("Internal Render Process" to JetpackCompose.INTERNAL_RENDER_PROCESS_URL), blogEnum = BlogEnum.InternalRenderProcessJC),
                    Blog(8, "", links = listOf("State Manage Compose" to JetpackCompose.STATE_MANAGE_URL), blogEnum = BlogEnum.StateManageJC),
                    Blog(9, "", links = listOf("Common wrapper state, Sandwich" to Constants.COMMON_WRAPPER_URL), blogEnum = BlogEnum.WrapperStateJC),
                    Blog(10, "", links = listOf("Stability" to JetpackCompose.SideEffect.STABILITY_URL), blogEnum = BlogEnum.StabilityJC),
                    Blog(11, "", links = listOf("Side effect / Effect handler" to JetpackCompose.SideEffect.SIDE_EFFECT_URL), blogEnum = BlogEnum.EffectHandlerJC),
                    Blog(12, "", links = listOf("CompositionLocal" to JetpackCompose.COMPOSITIONAL_LOCALS_URL), blogEnum = BlogEnum.CompositionLocalJC),
                    Blog(13, "", links = listOf("ViewModel" to JetpackCompose.VIEWMODEL_URL), blogEnum = BlogEnum.ViewModelJC),
                    Blog(14, "", links = listOf("AppState Transform" to JetpackCompose.SideEffect.APP_STATE_TRANSFORM_URL), blogEnum = BlogEnum.AppStateTransformJC),
                    Blog(15, "", links = listOf("Navigation" to JetpackCompose.NAVIGATION_URL), blogEnum = BlogEnum.NavigationJC),
                    Blog(16, "", links = listOf("Pagination" to JetpackCompose.PAGINATION_URL), blogEnum = BlogEnum.PaginationJC),
                    Blog(17, "", links = listOf("Animation" to JetpackCompose.ANIMATION_URL), blogEnum = BlogEnum.AnimationJC),
                    Blog(18, "", links = listOf("Hilt" to Constants.HILT_DI_URL), blogEnum = BlogEnum.HiltJC),
                    Blog(19, "", links = listOf("Basic, Koin, Annotations, Navigation" to Constants.KOIN_BASIC_URL), blogEnum = BlogEnum.KoinJC),
                    Blog(20, "", links = listOf("Room database" to Constants.ROOM_DATABASE_URL), blogEnum = BlogEnum.RoodDBJC),
                    Blog(21, "", links = listOf("Preferences dataStore" to JetpackCompose.PREF_STORE_URL), blogEnum = BlogEnum.DataStoreJC),
                    Blog(22, "", links = listOf("KTOR, ktorfit, Socket, RPC" to Constants.KTOR_URL), blogEnum = BlogEnum.KToRJC),
                    Blog(23, "", links = listOf("MVVM, Clean Architecture" to Constants.CLEAN_ARCHITECTURE_COMPOSE_URL), blogEnum = BlogEnum.CleanArchitectureJC),
                    Blog(24, "", links = listOf("MVI" to Constants.CLEAN_ARCHITECTURE_COMPOSE_MVI_URL), blogEnum = BlogEnum.MVIJC),
                    Blog(26, "", links = listOf("Search (Combine | Zip | Search | Filter)" to Coroutines.FILTER_URL), blogEnum = BlogEnum.FilterCoroutines),
                    Blog(27, "", links = listOf("kotest" to Constants.KOTEST_URL), blogEnum = BlogEnum.KoTestJC),
                    Blog(28, "", links = listOf("Interview Question - 42" to Constants.INTERVIEW_QUESTION_COMPOSE_URL), blogEnum = BlogEnum.QuestionJC),
                )
            )
        },

        //Kotlin Multiplatform
        KOTLIN_MULTIPLATFORM to buildList {
            addAll(
                listOf(
                    Blog(1, "", links = listOf("Basic" to KMM.BASIC_URL), blogEnum = BlogEnum.BasicKMP),
                    Blog(2, "", links = listOf("Material3 theme" to "https://medium.com/@kamal.lakhani56/kmp-material3-compose-1-6-3-69062552bc1b"), blogEnum = BlogEnum.Theme3KMP),
                    Blog(3, "", links = listOf("KMP Plugin" to KMM.KMP.PLUGIN_URL), blogEnum = BlogEnum.PluginKMP),
                    Blog(4, "", links = listOf("KMP Shared" to KMM.KMP.SHARED_VIEWMODEL_URL), blogEnum = BlogEnum.SharedPluginKMP),
                    Blog(5, "", links = listOf("Preference" to KMM.KMP.SECURE_STORAGE_URL), blogEnum = BlogEnum.PreferenceKMP),
                    Blog(6, "", links = listOf("Constraint" to KMM.KMP.CONSTRAINT_LOGIN_URL), blogEnum = BlogEnum.ConstraintKMP),
                    Blog(7, "", links = listOf("Realm database" to KMM.KMP.REALM_URL), blogEnum = BlogEnum.RealmDBKMP),
                    Blog(8, "", links = listOf("Firebase Generic" to KMM.KMP.FIREBASE_URL), blogEnum = BlogEnum.FirebaseKMP),
                )
            )
        },

        KOTLIN_MULTIPLATFORM to buildList {
            addAll(
                listOf(
                    Blog(1, "", links = listOf("Basic" to KMM.BASIC_URL), blogEnum = BlogEnum.BasicKMP),
                    Blog(2, "", links = listOf("Material3 theme" to "https://medium.com/@kamal.lakhani56/kmp-material3-compose-1-6-3-69062552bc1b"), blogEnum = BlogEnum.Theme3KMP),
                    Blog(3, "", links = listOf("KMP Plugin" to KMM.KMP.PLUGIN_URL), blogEnum = BlogEnum.PluginKMP),
                    Blog(4, "", links = listOf("KMP Shared" to KMM.KMP.SHARED_VIEWMODEL_URL), blogEnum = BlogEnum.SharedPluginKMP),
                    Blog(5, "", links = listOf("Preference" to KMM.KMP.SECURE_STORAGE_URL), blogEnum = BlogEnum.PreferenceKMP),
                    Blog(6, "", links = listOf("Constraint" to KMM.KMP.CONSTRAINT_LOGIN_URL), blogEnum = BlogEnum.ConstraintKMP),
                    Blog(7, "", links = listOf("Realm database" to KMM.KMP.REALM_URL), blogEnum = BlogEnum.RealmDBKMP),
                    Blog(8, "", links = listOf("Firebase Generic" to KMM.KMP.FIREBASE_URL), blogEnum = BlogEnum.FirebaseKMP),
                )
            )
        },

        KOBWEB to emptyList() ,

        //Kotlin Notebook
        KOTLIN_NOTEBOOK to buildList {
            addAll(
                listOf(
                    Blog(1, "", links = listOf("Kotlin Notebook" to Kotlin.NOTE_BOOK_URL), blogEnum = BlogEnum.NotebookKotlin)
                )
            )
        },

        //KDIS
        //https://draft.blogger.com/profile/02058721679925287753
        //https://edurev.in
        KIDS to buildList {
            addAll(
                listOf(
                    Blog(1, "", links = listOf("Basic Math" to Kids.Maths.BASIC_MATH_URL), blogEnum = BlogEnum.BasicMathKids),
                    Blog(2, "", links = listOf("Body" to Kids.EVS.BODY_URL), blogEnum = BlogEnum.BodyKids),
                    Blog(3, "", links = listOf("Family" to Kids.EVS.FAMILY_URL), blogEnum = BlogEnum.FamilyKids),
                    Blog(4, "", links = listOf("Earth" to Kids.EVS.EARTH_URL), blogEnum = BlogEnum.EarthKids),
                    Blog(5, "", links = listOf("Water" to Kids.EVS.WATER_URL), blogEnum = BlogEnum.WaterKids),
                    Blog(6, "", links = listOf("Air" to Kids.EVS.AIR_URL), blogEnum = BlogEnum.AirKids),
                    Blog(7, "", links = listOf("Sky Above" to Kids.EVS.SKY_URL), blogEnum = BlogEnum.SkyKids),
                    Blog(8, "", links = listOf("Weather" to Kids.EVS.WEATHER_URL), blogEnum = BlogEnum.WeatherKids),
                    Blog(9, "", links = listOf("Living in Different Seasons" to Kids.EVS.LIVING_SEASONS_URL), blogEnum = BlogEnum.LivingDifferentSeasonsKids),
                    Blog(10, "", links = listOf("Stories" to Kids.EVS.STORIES_URL), blogEnum = BlogEnum.StoriesKids),
                    Blog(11, "", links = listOf("Animals" to Kids.EVS.ANIMALS_URL), blogEnum = BlogEnum.AnimalsKids),
                    Blog(12, "", links = listOf("Indian Festival" to Kids.EVS.INDIAN_FESTIVAL_URL), blogEnum = BlogEnum.IndianFestivalKids),
                    Blog(13, "", links = listOf("Useful Places & Visit" to Kids.EVS.VISIT_PLACES_URL), blogEnum = BlogEnum.VisitPlacesKids),
                    Blog(14, "", links = listOf("Our Helper" to Kids.EVS.OUR_HELPER_URL), blogEnum = BlogEnum.OurHelperKids),
                    Blog(15, "", links = listOf("Communication" to Kids.EVS.COMMUNICATION_URL), blogEnum = BlogEnum.CommunicationKids),
                    Blog(16, "", links = listOf("Shelter (House, We Live In)" to Kids.EVS.SHELTER_URL), blogEnum = BlogEnum.ShelterKids),
                    Blog(17, "", links = listOf("Our school" to Kids.EVS.OUR_SCHOOL), blogEnum = BlogEnum.OurSchoolKids),
                    Blog(18, "", links = listOf("Ride To Read - Grade 2 Podar international school - CBSE" to ""), blogEnum = BlogEnum.RideToReader2Kids),
                    Blog(19, "", links = listOf("Dictation Test, Passage" to Kids.DICTATION_URL), blogEnum = BlogEnum.DictationKids)
                )
            )
        },

        //FlipKart Listing
        FLIPKART to buildList {
            addAll(
                listOf(
                    Blog(1, "", links = listOf("Label Cropping" to Listing.LABEL_CROPPING_URL), blogEnum = BlogEnum.LabelCropping),
                    Blog(2, "", links = listOf("Kitchen Trolley Metal Listing" to Listing.KITCHEN_TROLLEY_METAL_URL), blogEnum = BlogEnum.KitchenTrolleyListingFlipkart),
                    Blog(3, "", links = listOf("Wardrobe Plastic Listing" to Listing.WARDROBE_PLASTIC_URL), blogEnum = BlogEnum.WardrobePlasticListingFlipkart),
                    Blog(4, "", links = listOf("Step Ladder Listing" to Listing.STEP_LADDER_URL), blogEnum = BlogEnum.StepLadderListingFlipkart),
                    Blog(5, "", links = listOf("Cloth Dryer Listing" to Listing.CLOTH_DRYER_VERTICAL_URL), blogEnum = BlogEnum.ClothDryerListingFlipkart),
                    Blog(6, "", links = listOf("Paneer Press Maker Listing- (Square Shape, Round Shape)" to Listing.PANEER_PRESS_MAKER_URL), blogEnum = BlogEnum.PannerPressMakerListingFlipkart),
                    Blog(7, "", links = listOf("Wall Mounted (Mirror Cabinet) Listing- (Plastic, Wood)" to Listing.WALL_MOUNTED_URL), blogEnum = BlogEnum.WallMountedListingFlipkart),
                    Blog(8, "", links = listOf("Chopping Board" to Listing.CHOPPING_BOARD_URL), blogEnum = BlogEnum.ChoppingBoardFlipkart),
                )
            )
        }
    )

    val workList: PersistentList<Work> = persistentListOf(
            //Work(4, "Kotlin Multiplatform", "A smart solutions for creating cross-platform mobile applications with native performance and UIs. Share kotlin code between platforms, backend and an interoperability.", ""),
            Work(1, "Kotlin Multiplatform", "Streamline efficient multiplatform development, ensuring quality and reducing the cost of serving customers. ", KMM.BASIC_URL),
            Work(2, "Jetpack compose", "Declarative framework for sharing UIs across multiple platforms. Based on Kotlin, Kotlin multiplatform UI and Jetpack Compose.", JetpackCompose.BASIC_URL),
            Work(3, "KobWeb", "It is an opinionated framework built on top of Compose HTML. Creating everything you need to build rich, websites, while being able to leverage the greater Kotlin ecosystem. It support koin and ktor etc.", ""),

            Work(4, "Flutter", "I am dedicated Flutter app developer, I can provide high-quality flutter app development services flawlessly.", ""),
            Work(5, "FlutterFlow", "Our approach centers around leveraging the power of Flutterflow- A No-code platform. From concept to creation, we harness cutting-edge tools to deliver stunning applications.", ""),
            Work(6, "React native", "I develop cross-platform mobile apps that offer the best of both worlds – a native-like experience on iOS and Android.", ""),

            Work(7, "Ecommerce solution", "Comprehensive e-commerce solutions with newest technology & trends that attract targeted audiences to your business.", ""),
            Work(8, "KVision", "KVision allows you to build modern web applications with the Kotlin language, without any use of HTML, CSS or JavaScript. KVision fully supports both reactive and imperative programming models.", ""),
            Work(9, "WordPress", "WordPress to your needs, we develop feature-rich and easy-to-manage websites that reflect your brand identity and engage your real world business.", ""),
            Work(10, "Web developments", "We have developed numerous customs, dynamic and e-commerce websites for all fields industry and clients from all over the world.", ""),
            Work(11, "Support & Maintenance", "As technologies changes, websites and mobile apps need to update. We Offering 24/7 support system, you can reach us by call or live chat.", "")
    )

    val projectList: PersistentList<Project> = persistentListOf(
            Project(src = Resources.Images.PROJECT_CUSTOMER_SERVICE, title = "Customer Service", description = "", url = Constants.PROJECT_CUSTOMER_SERVICE_URL, language = "Flutter"),
            Project(src = Resources.Images.PROJECT_FOOD_CAFE, title = "Food Cafe", description = "", url = Constants.PROJECT_FOOD_CAFE_URL, language = "Flutter"),
            Project(src = Resources.Images.PROJECT_MVP_EVENT_STAFFING, title = "MVP Event Staffing", description = "", url = Constants.PROJECT_MVP_EVENT_STAFFING_URL, language = "Flutter"),
            Project(src = Resources.Images.PROJECT_MIKAN_DELIVERY, title = "Mikan Delivery", description = "", url = Constants.PROJECT_MIKAN_DELIVERY_URL, language = "Flutter"),
            Project(src = Resources.Images.PROJECT_SERVICE_PROVIDER, title = "Service Provider", description = "", url = Constants.PROJECT_SERVICE_PROVIDER_URL, language = "Flutter"),

            Project(src = Resources.Images.PROJECT_CODE_ARTICLE, title = "Code Article", description = "", url = "", language = "Jetpack Compose"),
            Project(src = Resources.Images.PROJECT_CODE_TASKII, title = "Taskii", description = "", url = "", language = "Jetpack Compose"), //https://github.com/3wiida/Taskii //https://github.com/shivam1814/Todo-List-CMP

            Project(src = Resources.Images.PROJECT_SHOPPING_MALL, title = "Shopping Mall", description = "", url = "", language = "Kotlin Multiplatform"), //https://github.com/Joker-x-dev/CoolMallKotlin.git
            Project(src = Resources.Images.PROJECT_ATTENDANCE, title = "Attendance", description = "", url = "", language = "Kotlin Multiplatform"), //https://github.com/milkandvodka/KITO

            Project(src = Resources.Images.PROJECT_MONITO_2, title = "Monito", description = "", url = "", language = "Kotlin Multiplatform"),
            Project(src = Resources.Images.PROJECT_CRYPTO, title = "Crypto", description = "", url = "", language = "Kotlin Multiplatform"),

            Project(src = Resources.Images.PROJECT_OPTIMITE_MEMORY, title = "Optimite Memory", description = "", url = "", language = "Kotlin Multiplatform"), //https://github.com/Quantum3600/Optimite.git
            Project(src = Resources.Images.PROJECT_MEMORY_MATCH, title = "Memory Match", description = "", url = "", language = "Kotlin Multiplatform"), //https://github.com/smithjustinn84-netizen/Memory-Match.git

            Project(src = Resources.Images.PROJECT_GRIPPO, title = "Exercise", description = "", url = "", language = "Kotlin Multiplatform"), //https://github.com/Grippo-app/grippo-mobile
    )


    /*fun addBlog(blog: Blog) {
        blogList.add(blog)
    }

    fun deleteBlog(index: Int) {
        blogList.removeAt(index)
    }

    fun editBlog(blog: Blog) {
        val index = blogList.indexOfFirst { it.index == blog.index }
        if (index != -1) {
            blogList[index] = blogList[index].copy(
                totalView = blog.totalView,
                title = blog.title,
                description = blog.description,
                link = blog.link
            )
        }
    }*/
}
